/** Страницата, към която банката връща клиента. */
export default {
  titles: {
    loading: "Потвърждаване на плащането…",
    success: "Успешно плащане",
    failed: "Плащането не е завършено",
    error: "Нещо се обърка",
  },
  messages: {
    cancelled: "Плащането ви не е завършено и не е удържана сума.",
    unmatched:
      "{{bank}} върна резултат, който не успяхме да свържем с поръчка. Ако сума е удържана, свържете се с поддръжката.",
    noInfo: "Не е открита информация за плащане.",
    stillConfirming: "{{bank}} все още потвърждава плащането ви…",
    notFound:
      "Нямаме данни за завършено плащане по тази поръчка, така че не е удържана сума. Можете да опитате отново.",
    notConfirmedYet:
      "{{bank}} все още не е потвърдила плащането ви. Можете да затворите тази страница — продължаваме да проверяваме и точките ви ще бъдат добавени веднага щом плащането бъде потвърдено.",
    declinedWithReason: "Плащането ви не е завършено: {{reason}}.",
    declinedWithReasonCode: "Плащането ви не е завършено: {{reason}} (статус {{code}}).",
    declined: "Плащането ви е отказано или не е завършено.",
    declinedCode: "Плащането ви е отказано или не е завършено (статус {{code}}).",
    activatedGuest:
      "Планът ви е активиран. Създайте профил (или влезте) с имейла, който използвахте при поръчката, за да използвате точките си.",
    alreadyConfirmed: "Това плащане вече е потвърдено и точките ви са активни.",
    authorised:
      "Плащането ви е оторизирано и точките ви са добавени. Сумата ще бъде окончателно удържана скоро.",
    activated: "Планът ви е активиран и точките са добавени.",
    verifyFailed:
      "Не успяхме да потвърдим плащането ви: {{reason}} Ако сума е удържана, свържете се с поддръжката, като посочите поръчка {{orderId}}.",
  },
  receipt: {
    title: "Вашата разписка",
    emailed: "Изпратихме разписката ви на имейл адреса, въведен при поръчката. Можете да я изтеглите и тук.",
  },
  createAccount: "Създайте профил",
  goToProfile: "Към профила",
};
